export default "__VITE_ASSET__CtyYjtMH__"